import { createSelectorCreator, defaultMemoize } from 'reselect';
import isEqual from 'lodash.isequal';

const createDeepEqualSelector = createSelectorCreator(defaultMemoize, isEqual);

const selectSubmittings = state => state.submitting;
const selectNamespace = (state, props) => props.namespace;

export const selectIsSubmitting = () =>
    createDeepEqualSelector(selectSubmittings, submittingsState =>
        Object.values(submittingsState).some(value => value)
    );

export const makeSelectSubmitting = namespace =>
    createDeepEqualSelector(
        [selectSubmittings, selectNamespace],
        (submittingsState, namespaceState) => {
            const namespaceValue = namespaceState || namespace;
            if (namespaceValue.constructor === Array) {
                return namespaceValue.reduce(
                    (acc, cur) => (acc ? true : submittingsState[cur]),
                    false
                );
            }
            return submittingsState[namespaceValue];
        }
    );

export default { selectIsSubmitting, makeSelectSubmitting };
